module.exports = __webpack_public_path__ + "img/poster.005bcdf6.png";